import React from "react";
import "./styles.scss";

const History = () => (
    <section className="history">
        <div className="inner history__inner">
            <div className="history__content">
                <h1 className="history__title">History of Orca</h1>
                <p className="history__text">
                    Orca was founded in 2015 with the goal of driving the
                    adoption and growth of an exciting new asset class: Direct
                    Lending. Direct lending has the potential to disintermediate
                    banks and large financial institutions, with the benefits
                    going to both lenders and borrowers.
                </p>
                <p className="history__text">
                    Since inception, Orca has been providing research services,
                    risk management and reporting across the direct lending
                    industry. In 2017, Orca launched the industry-leading Orca
                    Investment Platform, an efficient and cutting-edge way to
                    invest across the P2P market.
                </p>
                <p className="history__text">
                    Based in Edinburgh and Belfast, our experienced team are
                    here to help you navigate your way into the direct lending
                    space.
                </p>
            </div>
        </div>
    </section>
);

export default History;
